// Pure selection helpers for the logged-out homepage (tested in landingData.test.js).
import { requirementSentence } from '@aluvo/constants/src/collectionCompletion';

/** A collection a visitor can still complete today. */
export function isFeaturableCollection(c) {
    return Boolean(c?.slug) && c.canEarnReward !== false && c.availabilityStatus !== 'ended';
}

/**
 * Up to `count` items: the preferred slugs first (in order, when present and
 * allowed), then the remaining allowed items in API order.
 */
export function pickFeatured(items, preferredSlugs, { count, allow = () => true, exclude = [] } = {}) {
    const usable = (items || []).filter((item) => item?.slug && allow(item) && !exclude.includes(item.slug));
    const bySlug = new Map(usable.map((item) => [item.slug, item]));
    const preferred = preferredSlugs.map((slug) => bySlug.get(slug)).filter(Boolean);
    const rest = usable.filter((item) => !preferredSlugs.includes(item.slug));
    return [...preferred, ...rest].slice(0, count);
}

/** The hero collection, or the first other active collection with a Signature reward. */
export function pickHeroCollection(collections, slug) {
    const usable = (collections || []).filter(isFeaturableCollection);
    return usable.find((c) => c.slug === slug)
        || usable.find((c) => c.reward?.media?.type === 'ANIMATED')
        || null;
}

/** "Verify all 5 titles" or "Verify any 5 of 8 titles". */
export function collectionRequirementLine(collection) {
    const sentence = requirementSentence(collection, { rewardName: 'the reward' });
    return sentence.replace(/ to unlock the reward\.$/, '');
}
